import type * as React from 'react';

import { cn } from '../../lib/utils';

export interface AppHeaderProps {
  title: string;
  /** User trigger + popover container. Rendered inside a relative-positioned wrapper. */
  userSlot: React.ReactNode;
  className?: string;
}

export const AppHeader: React.FC<AppHeaderProps> = ({ title, userSlot, className }) => {
  return (
    <div className={cn('flex items-center justify-between shrink-0', className)}>
      <p className="text-[24px] font-bold text-dawn-black font-outfit leading-[1.2] capitalize truncate">
        {title}
      </p>
      <div className="relative">{userSlot}</div>
    </div>
  );
};

AppHeader.displayName = 'AppHeader';
